import { HeartPulse } from "lucide-react";
import { Input } from "./ui/input";
import AutocompleteInput from "./AutocompleteInput";

export const isConducenteFerito = (ruolo) => { const s = String(ruolo || "").toLowerCase(); return s.includes("conducente") && s.includes("ferit"); };

// Scheda lesioni del conducente ferito: dati del Pronto Soccorso (usati nel foglio 2 della CAI).
export default function LesioniPSCard({ form, set, testId = "lesioni-ps" }) {
  const ric = form.ps_ricovero || "";
  return (
    <div className="rounded-lg border border-rose-500/40 bg-rose-500/[0.06] p-3 space-y-3" data-testid={testId}>
      <div className="flex items-center gap-2 text-sm font-head font-bold uppercase tracking-wide text-rose-300"><HeartPulse className="h-4 w-4" /> Lesioni — Pronto Soccorso</div>
      <div>
        <span className="text-slate-300 text-xs uppercase tracking-wide">Nome Pronto Soccorso</span>
        <Input value={form.ps_nome || ""} onChange={(e) => set("ps_nome", e.target.value)} data-testid={`${testId}-nome`} className="mt-1.5 h-9 bg-slate-900/60 border-slate-700" placeholder="es. Ospedale Villa Sofia" />
      </div>
      <div>
        <span className="text-slate-300 text-xs uppercase tracking-wide">Città Pronto Soccorso</span>
        <div className="mt-1.5"><AutocompleteInput value={form.ps_citta || ""} onChange={(v) => set("ps_citta", v)} source="comuni" testId={`${testId}-citta`} /></div>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-slate-300 text-xs uppercase tracking-wide">Ricovero Pronto Soccorso</span>
        {[["si", "Sì"], ["no", "No"]].map(([v, l]) => (
          <button key={v} type="button" onClick={() => set("ps_ricovero", ric === v ? "" : v)} data-testid={`${testId}-ricovero-${v}`}
            className={`px-3 py-1 rounded text-sm border transition-colors ${ric === v ? "bg-rose-600 border-rose-500 text-white" : "border-slate-600 text-slate-300 hover:bg-slate-800"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}
